import { range } from "lodash";
import { getWidth } from "../common";

const columns = 5;
export default range(columns).map(current => {
  const field = `sensor_photomicro_transmissive_${current + 1}`;
  return {
    field,
    label: field,
    width: getWidth(columns),
    isSortable: false,
    isCSV: true
  };
});
